import React from "react"

import { useEvent } from "shared/lib/useEvent"

import { ProjectPageFloorTab } from "pages/project-page/ui/project-page-tab-bar/ProjectPageFloorTab"
import { FloorTabRendererProps } from "pages/project-page/ui/project-page-tab-bar/ProjectPageFloorTabConnector"

export const SharedProjectPageFloorTabConnector = React.memo(
  (props: FloorTabRendererProps) => {
    const onOpenDetails = useEvent(() => props.onSelectFloor(props.floor.id))

    return (
      <ProjectPageFloorTab
        floor={props.floor}
        index={props.index}
        ariaControls={props.ariaControls}
        onDrop={undefined}
        truncationThreshold={props.truncationThreshold}
        handlers={undefined}
        onOpenDetails={onOpenDetails}
      />
    )
  }
)

SharedProjectPageFloorTabConnector.displayName =
  "SharedProjectPageFloorTabConnector"
